module.exports = __webpack_public_path__ + "static/media/bgLogin.665be407.png";